import "./loader.css";

export function Loader() {
   return (
      <div className="loader-layout">
         <div className="loader-container">
            <div className="loader"></div>
         </div>
      </div>
   );
}
